export class StorageUtils {
  get(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      console.error("Error getting item from localStorage", e);
      return null;
    }
  }

  set(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      console.error("Error setting item in localStorage", e);
    }
  }

  delete(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.error("Error deleting item from localStorage", e);
    }
  }
}

export const storageUtils = new StorageUtils();
